import React from "react";
import "./Admission_Process.css";
import Main_heading_holder from "../../common_components/main_heading_holder/Main_heading_holder";

const Admission_Process = () => {
  return (
    <section className="Admission_Process" id="admissions">
      <div className="container">
        {/* <div className="col_header">
          <h5 className="col_title">Online MBA Admission Process </h5>
        </div> */}

        <Main_heading_holder
          heading="Online MBA "
          spanHeading=" Admission Process"
          headingType="h3"
        />

        <div className="admission_img_wrapper">
          <img
            src="/assets/edtech_assets/images/online_mba/Admission_Process/img-1.webp"
            className="admission_img"
          />
        </div>
      </div>
    </section>
  );
};

export default Admission_Process;
